import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserAuthService {
  user: any;

  public loggedIn = new BehaviorSubject<boolean>(false);
  public loggedUser?: boolean = false;
  public roleCount = 0;
  public counter = 0;

  /**
   * @constructor
   * @param {HttpClient} http: HTTP client for API calls.
   */
  constructor(private http: HttpService<any>) { }

  setUser(roles: any) {
    localStorage.setItem('USER_ID', roles.id);
    localStorage.setItem('ROLE', roles.role);
    localStorage.setItem('EMAIL', roles.email);
    localStorage.setItem('FIRST_NAME', roles.firstName);
    localStorage.setItem('LAST_NAME', roles.lastName);
    localStorage.setItem('PACEFILLS_USER_ID', roles.paceFillsUserId);
    this.loggedIn.next(true);
  }

  getUser() {
    if (this.user) {
      this.loggedIn.next(false);
    }
    var roles = localStorage.getItem('ROLE');
    this.user = {
      id: localStorage.getItem('USER_ID'),
      email: localStorage.getItem('EMAIL'),
      firstName: localStorage.getItem('FIRST_NAME'),
      lastName: localStorage.getItem('LAST_NAME'),
      paceFillsUserId: localStorage.getItem('PACEFILLS_USER_ID'),

      role: roles,
    };
    this.loggedIn.next(true);

    return this.user;
  }

  getRole() {
    return this.user.role;
  }

  getUserRoles(): Observable<any> {
    var url = '/users/information';
    return this.http.get(url);
  }

  getCache(): Observable<any> {
    var url = '/users/selection';
    return this.http.get(url);
  }

  setUserSelection(userSelection: any): Observable<any> {
    var url = '/users/selection';
    return this.http.post(userSelection, url);
  }

  isAuthorized(allowedRoles: any): boolean {
    if (!allowedRoles) return true;
    const userRole = [this.user.role];

    if (!userRole) return false;
    return userRole.some((role: string) =>
      allowedRoles.includes(role),
    );
  }

  /**
   * Sets login observable and variable to false to hide sidebar.
   * Redirects to login.
   */
  logout() {
    localStorage.clear();
    var url = environment.authUrl;
    window.location.href = url + 'logout';
  }
}
